module.exports = __webpack_public_path__ + "static/8-bfbd5d6d58364d1b3b018ce92e15ee0a.jpeg";